export interface MaterialTypeSchema {
  id: string;
  name: string;
  description: string;
  /** The catalog material this is an alias for. The basket and every catalog
   *  lookup key off this, not off `id`. */
  material_id: string | null;
  organization_id: string | null;
  parent_category: string | null;
  unit_of_measure: string | null;
  extra_data: Record<string, any>;
  created_at: string;
  updated_at: string;
}

export interface MaterialTypeRequest {
  name: string;
  description: string;
  parent_category: string;
  organization_id: string;
  unit_of_measure: string;
  extra_data?: Record<string, any>;
}

export interface UpdateMaterialTypeRequest {
  name?: string;
  description?: string;
  parent_category?: string | null;
  organization_id?: string | null;
  unit_of_measure?: string | null;
  extra_data?: Record<string, any>;
}

export interface MaterialTypeQueryParams {
  page?: number;
  limit?: number;
  search?: string;
}

export interface PaginatedMaterialTypeResponse {
  materialTypes: MaterialTypeSchema[];
  total: number;
}


export enum MaterialsMainCategoriesTypes {
  ORGANIC = "organic",
  CARDBOARD = "cardboard",
  PLASTIC = "plastic",
  METAL = "metal",
  WOOD = "wood",
  SLUDGE = "sludge",
  MIXED = "mixed",
  CHEMICAL = "chemical",
  EWASTE = "e_waste",
  OIL = "oil",
  HAZARDOUS_WASTE = "hazardous_waste",
  RUBBER = "rubber",
  TEXTILES = "textiles",
  GLASS = "glass",
  OTHER = "other",
}


export enum MaterialUnitOptions {
  KG = "kg",
  TONS = "tons",
  LBS = "lbs",
  BAGS = "bags",
  CARTONS = "cartons",
  BOTTLES = "bottles",
  PALLETS = "pallets",
  CUBIC_YARDS = "cubic_yards",
  CUBIC_METERS = "cubic_meters",
  LITERS = "liters",
  GALLONS = "gallons",
}
